import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import ObjectListItem from '../../generic/ObjectListItem';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const ObjectListItemWidget = (props) => {
    const component = useMemo(() => props.contextCustomer ? (_jsx(ObjectListItem, { viewObject: { matchedPrimary: props.contextCustomer }, transactionFunctions: props.transactionFunctions })) : (_jsx(_Fragment, {})), [props.contextCustomer]);
    return {
        name: 'ObjectListItem',
        category: 'generic',
        component,
    };
};
